import { Link } from 'react-router-dom'
import { RotateCcw, Send, UserCheck } from 'lucide-react'

export interface DuplicateUserInfo {
  user_id: string
  deleted: boolean
  has_logged_in: boolean
  full_name: string | null
}

interface Props {
  email: string
  duplicate: DuplicateUserInfo
  onClose: () => void
  onResendInvite: () => void
  onRestore: () => void
  isPending: boolean
}

export default function InviteAgainModal({ email, duplicate, onClose, onResendInvite, onRestore, isPending }: Props) {
  // Уже активный и хотя бы раз входивший сотрудник — приглашать нечего, это реальный пользователь
  const alreadyWorking = !duplicate.deleted && duplicate.has_logged_in

  return (
    <>
      <div className="fixed inset-0 z-50 bg-black/40" onClick={onClose} />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
        <div className="pointer-events-auto w-full max-w-sm rounded-xl bg-white shadow-2xl p-6">
          <div className="flex items-start gap-3 mb-4">
            <div className="flex-shrink-0 mt-0.5 rounded-full bg-brand-50 p-1.5">
              {alreadyWorking
                ? <UserCheck className="h-4 w-4 text-brand-600" />
                : duplicate.deleted
                  ? <RotateCcw className="h-4 w-4 text-brand-600" />
                  : <Send className="h-4 w-4 text-brand-600" />}
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">
                {alreadyWorking
                  ? 'Сотрудник уже работает в системе'
                  : duplicate.deleted
                    ? 'Этот сотрудник был удалён'
                    : 'Приглашение уже отправлено'}
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                {alreadyWorking
                  ? `${email} - это ${duplicate.full_name ?? 'действующий сотрудник'}, он уже пользуется системой. Изменить роль можно в его карточке.`
                  : duplicate.deleted
                    ? `${email} есть в корзине удалённых сотрудников. Восстановить и отправить новое приглашение?`
                    : `${email} уже добавлен и ждёт первого входа. Отправить приглашение ещё раз?`}
              </p>
            </div>
          </div>
          <div className="flex gap-2 justify-end">
            <button
              onClick={onClose}
              className="rounded-lg border border-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Закрыть
            </button>
            {alreadyWorking ? (
              <Link
                to={`/users/${duplicate.user_id}`}
                onClick={onClose}
                className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 transition-colors"
              >
                К сотруднику
              </Link>
            ) : (
              <button
                onClick={duplicate.deleted ? onRestore : onResendInvite}
                disabled={isPending}
                className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700 disabled:opacity-50 transition-colors"
              >
                {isPending ? 'Подождите...' : duplicate.deleted ? 'Восстановить и пригласить' : 'Пригласить повторно'}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
